export default __webpack_public_path__ + "static/media/bellIconBlue.062bf167.svg";